import React, { Fragment } from 'react';
import { useIntl } from 'react-intl';


// Components

import SummaryItem from '../SummaryItem';

// Utils

import { formatDate, subtractFromDateWithFormat, toUTCAndFormat } from '@utils/dates/date.utils';
import { questionsVisibility } from '@utils/miscellaneous/pageAndQuestionsVisibility';

// Constants

import { DATE_FORMATS } from '@utils/dates/dateMethods';
import { YYYY } from '@utils/dates/dateFormats.utils';


const MedicaidChipInfo = props => {

    const {
        DATE_FORMAT
    } = DATE_FORMATS;

    const {
        applyingForCoverageIndicator,
        changeInImmigrationSince5Year,
        changeInImmigrationSinceMedicaidDenial,
        exchangeAndProgramNames,
        idx,
        medicaidChipDenial,
        medicaidDeniedDate,
        medicaidDeniedDueToImmigration,
        medicaidEndDateOverride,
        medicaidTerminationFeatureEnabled,
        member,
        serverDate
    } = props;

    const intl = useIntl();
    const { exchangeMedicaid, exchangeMedicaidOrChip } = exchangeAndProgramNames;
    const isVisible = applyingForCoverageIndicator &&
        questionsVisibility.isMedicaidChipDenialShown({
            hhm: member,
            medicaidTerminationFeatureEnabled,
            serverDate,
            medicaidEndDateOverride
        });

    if (!isVisible) {
        return null;
    }

    const fiveYearsAgo = subtractFromDateWithFormat(5, 'year', YYYY, serverDate);

    const getMedicaidDeniedDate = date => {
        // This is a small helper to return a custom message.
        return formatDate(date, DATE_FORMAT) === 'Invalid Date'
            ? intl.formatMessage({ id: 'common.not_available' }) 
            : toUTCAndFormat(date, DATE_FORMAT);
    };

    return (
        <Fragment>
            <SummaryItem
                textCode = 'common.medicaid_not_eligible'
                replacements={{ exchangeMedicaid, exchangeMedicaidOrChip } }
                value = { medicaidChipDenial }
                desc = {
                    [
                        [
                            `taxHousehold.householdMember[${ idx }].medicaidChipDenial`
                        ]
                    ]
                }
            />
            {
                medicaidChipDenial &&

                <Fragment>
                    <SummaryItem
                        textCode='common.medicaid_denied_chip'
                        replacements={{exchangeMedicaidOrChip}}
                        value = { getMedicaidDeniedDate(medicaidDeniedDate) }
                        ignoreIntl
                        desc = {
                            [
                                [
                                    `taxHousehold.householdMember[${ idx }].medicaidDeniedDate`,
                                    getMedicaidDeniedDate
                                ]
                            ]
                        }
                    />
                    <SummaryItem
                        category = 'common.medicaid_not_eligible_since'
                        replacements = { {
                            fiveYearsAgo,
                            exchangeMedicaidOrChip
                        } }
                        value = { medicaidDeniedDueToImmigration }
                        desc = {
                            [
                                [
                                    `taxHousehold.householdMember[${ idx }].medicaidDeniedDueToImmigration`
                                ]
                            ]
                        }
                    />
                    {
                        medicaidDeniedDueToImmigration &&

                        <Fragment>
                            <SummaryItem
                                category = 'common.change_in_is_since'
                                replacements = { {
                                    fiveYearsAgo
                                } }
                                value = { changeInImmigrationSince5Year }
                                desc = {
                                    [
                                        [
                                            `taxHousehold.householdMember[${ idx }].changeInImmigrationSince5Year`
                                        ]
                                    ]
                                }
                            />
                            {
                                changeInImmigrationSince5Year &&

                                <SummaryItem
                                    textCode = 'common.immigration_status_change_medicaid'
                                    replacements={{ exchangeMedicaidOrChip }}
                                    value = { changeInImmigrationSinceMedicaidDenial }
                                    desc = {
                                        [
                                            [
                                                `taxHousehold.householdMember[${ idx }].changeInImmigrationSinceMedicaidDenial`
                                            ]
                                        ]
                                    }
                                />
                            }
                        </Fragment>
                    }
                </Fragment>
            }
        </Fragment>
    );
};

export default MedicaidChipInfo;